export default __webpack_public_path__ + "static/media/starYellow.1d014059.svg";